export const Util = {
    wait: (ms) => {
        return new Promise((resolve) => setTimeout(resolve, ms));
    },
};
//# sourceMappingURL=Util.js.map